var RecentLocations, RecentSearches, allTranslations, createBloodhoundTag, deEmphasis, getAutocompleteList, getHeadingPartial, getRecentSearches, getSubCategoryCollection, getTranslations, matchListItem, moveAutocomplete, normalizeQuery, partialAutocompleteList, partialCurrentLocation, partialLocationHelper, partialRecentSearchesList, partialSearchCategories, partialSearchCategoryList, prepareBloodhoundTag, removeRecentSearch, removeRecentSearches, saveRecentSearch, setRecentSearches, setTranslations, templateAttributesForSubcategories, toCamelCase,
  slice = [].slice;

normalizeQuery = require('./m_normalizeQuery');

toCamelCase = require('../../../../../src/helpers/camelCase').toCamelCase;


/**
 * @type {Object} allTranslations Global closure to cache translations
 */

allTranslations = {};


/**
 * @type {Array} RecentSearches Global closure to cache recent searches terms
 */

RecentSearches = [];


/**
 * @type {Array} RecentLocations Global closure to cache recent location searches
 */

RecentLocations = [];


/**
 * Injects html tags to separate the neighborhood and the city
 *
 * @param   {String} label - Location with strong tags
 * @returns {String}
 */

deEmphasis = function(label) {
  var res;
  res = label.split(/,(.+)?/);
  if (res.length < 2) {
    return label;
  }
  if (res[0].includes('</strong>') || res[1].includes('<strong>')) {
    res.splice(1, 0, '<em>');
  } else {
    res.splice(1, 0, '</strong><em><strong>');
  }
  res.splice(3, 0, '</em>');
  return res.join('');
};


/**
 * Generate basic bloodhound tag name
 *
 * @param   {String} [type]     - Name of the api / collection name
 * @param   {String} attributes
 * @returns {String} bhw        - Base bloodhound tag
 */

createBloodhoundTag = function(type) {
  var bhw;
  if (type == null) {
    type = '';
  }
  type = type.split('|').map(function(i) {
    return toCamelCase(i);
  }).join('');
  bhw = "TouchSearchCategory" + type;
  return bhw;
};


/**
 * Method to build general (deal|location) autocomplete partial
 *
 * @param   {Array}  collections           - List of items returned from autocomplete
 * @param   {String} normQuery             - Normalized term entered by user
 * @param   {Number} [indexShift]          - Shift the index e.g due to previously processed collection
 * @returns {Object} {list, index, prefix}
 */

partialAutocompleteList = function(collections, normQuery, indexShift) {
  var index, item, label, lat, len, list, lng, locationPartial, n, queryLength, template, value;
  if (indexShift == null) {
    indexShift = 0;
  }
  queryLength = normQuery.length + 2;
  len = collections.length - 1;
  index = -1;
  list = [];
  locationPartial = '';
  while (item = collections.shift()) {
    lat = item.lat, lng = item.lng, label = item.label, value = item.value;
    if (lat) {
      locationPartial = " data-lat='" + lat + "' data-lng='" + lng + "'";
      if (item.neighborhood) {
        label = deEmphasis(label);
      }
    }
    n = len - collections.length;
    if (queryLength >= value.length && normQuery === normalizeQuery(value)) {
      index = n + indexShift;
    }
    template = "<li role='listitem' class='tw-item'>\n<a class='tw-link' id='tw" + n + "' tabindex='0' data-bhc='result-" + n + ":" + value + "' data-value='" + value + "'" + locationPartial + ">" + label + "</a>\n</li>";
    list.push(template);
  }
  return {
    list: list,
    index: index,
    prefix: 'tw'
  };
};


/**
 * LS-2211 current location / geolocation
 * Adds geolocation partial and handles matching
 *
 * @param   {String} widget         - Widget name
 * @param   {String} normQuery      - Normalized term user entered
 * @param   {Number} index          - Matched item index
 * @returns {Object} {list, index}
 */

partialCurrentLocation = function(widget, normQuery, index) {
  var list, normLabel, template, translations;
  translations = getTranslations();
  normLabel = normalizeQuery(translations.search.currentlocation);
  template = "<li role='listitem'>\n<a class='current-location icon-compass-needle tw-link' tabindex='0' data-value='" + translations.search.currentlocation + "' data-bhw='" + widget + "'>" + translations.search.currentlocation + "</a>\n</li>";
  list = [template];
  if (index > -1) {
    index = index + 1;
  }
  if (normQuery === normLabel) {
    index = index + 1;
  }
  return {
    list: list,
    index: index
  };
};


/**
 * LS-2685 Location Helper message
 * Adds message to help users when searching locations
 *
 * @returns {Array}
 */

partialLocationHelper = function() {
  var template, text, translations;
  translations = getTranslations();
  text = translations.search.helpermsg;
  template = "<li role='listitem'>\n<span class='tw-msg ls-location-helper'><span class=\"new-badge\">NEW</span>" + text + "</span>\n</li>";
  return [template];
};


/**
 * Adds recent searches partial
 *
 * @param   {String} widget         - Widget name
 * @param   {Array}  collection     - List of items to build recent searches widget
 * @param   {Object} [config]       - Configuration containing experiments settings, etc. (Optional)
 * @returns {Object} {list, prefix}
 */

partialRecentSearchesList = function(widget, collection, config) {
  var address, bhc, clearingHeadingPartial, clearingPartial, ctx, division, hasClearingExperiment, item, lat, list, lng, n, ref, template, text, translations;
  if (config == null) {
    config = {};
  }
  translations = getTranslations();
  list = [];
  text = '';
  n = 0;
  clearingPartial = '';
  clearingHeadingPartial = '';
  if ((hasClearingExperiment = (ref = config.experiments) != null ? ref['LS-1744-clear-recent-searches'] : void 0) && (hasClearingExperiment != null ? hasClearingExperiment.setClearX : void 0)) {
    clearingPartial = "<span class='tw-clear icon-x' tabindex='0' aria-label='" + translations.ax.remove + "'></span>";
  }
  switch (widget) {
    case 'recentSearches':
      text = translations.search.recentdeals;
      ctx = 'deal';
      while (item = collection.shift()) {
        bhc = prepareBloodhoundTag(item);
        template = "<li role='listitem' class='tw-item tw-recent'>\n<a class='tw-link' id='twr" + n + "' tabindex='0' data-bhc='" + widget + ":" + bhc + "' data-value='" + item + "'>" + item + "</a>" + clearingPartial + "\n</li>";
        list.push(template);
        n++;
      }
      break;
    case 'recentLocations':
      text = translations.search.recentlocations;
      ctx = 'location';
      while (item = collection.shift()) {
        lat = item.lat, lng = item.lng, address = item.address, division = item.division;
        bhc = prepareBloodhoundTag(address);
        division = division ? "data-division='" + division + "'" : '';
        template = "<li role='listitem' class='tw-item tw-recent'>\n<a class='tw-link' id='twr" + n + "' tabindex='0' data-bhc='" + widget + ":" + bhc + "' data-lat='" + lat + "' data-lng='" + lng + "' data-value='" + address + "' " + division + ">" + address + "</a>" + clearingPartial + "\n</li>";
        list.push(template);
        n++;
      }
  }
  if (list.length) {
    if (hasClearingExperiment && (hasClearingExperiment != null ? hasClearingExperiment.setClearAll : void 0)) {
      clearingHeadingPartial = "<span class='tw-clear' ctx='" + ctx + "'>" + translations.search.clearall + "</span>";
    }
    list.unshift("<li class='tw-heading tw-recent'>" + text + clearingHeadingPartial + "</li>");
  }
  return {
    list: list,
    prefix: 'twr'
  };
};


/**
 * Build L1 Category header partial
 *
 * @param   {String}  type           - category type
 * @returns {String}  partial        - HTML partial containing L0 category heading
 */

getHeadingPartial = function(type) {
  var partial, translations, txt;
  translations = getTranslations();
  partial = '';
  txt = translations != null ? translations.categories[type] : void 0;
  return partial = txt ? "<div class='tw-heading tw-" + type + "'>" + txt + "</div>" : '';
};

templateAttributesForSubcategories = function() {
  var args, ariaAttributes, ariaListAttributes, bhw, catInfo, htmlCloseTag, htmlOpenTag, id, menuID, prefix, sectionID;
  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  id = args[0], sectionID = args[1], prefix = args[2], bhw = args[3];
  htmlOpenTag = 'span class="icon-plus tw-caption"';
  htmlCloseTag = 'span';
  menuID = prefix + "tw-" + id + "-menu";
  ariaAttributes = " role='link' aria-controls='" + menuID + "' aria-owns='" + menuID + "' aria-haspopup='true' ";
  catInfo = " cat='" + id + "' cat-path='" + sectionID + "|" + id + "'";
  ariaListAttributes = ' aria-live="polite"';
  return [htmlOpenTag, htmlCloseTag, ariaAttributes, ariaListAttributes, catInfo];
};


/**
 * Build Category partial
 *
 * @param   {Array}   collection - List of items
 * @param   {String}  sectionID  - category section name
 * @param   {Number}  [level]    - Optional parameter representing the taxonomy
 * @param   {Number}  [prefix]   - Optional prefix for id generation
 * @returns {String}             - HTML String
 */

partialSearchCategoryList = function(collection, sectionID, level, prefix) {
  var ariaAttributes, ariaListAttributes, attributes, baseBHW, baseObject, baseUrl, bhw, catInfo, count, countString, friendlyName, htmlCloseTag, htmlOpenTag, id, item, list, menuID, newBadge, newBadgeTag, newBadgeTxt, subcategories, template, url;
  if (level == null) {
    level = 1;
  }
  if (prefix == null) {
    prefix = '';
  }
  if (!(collection != null ? collection.length : void 0)) {
    return '';
  }
  list = [];
  url = '';
  baseBHW = createBloodhoundTag(sectionID);
  baseObject = collection.shift();
  baseUrl = baseObject.baseUrl;
  if (!baseUrl) {
    baseUrl = false;
    collection.unshift(baseObject);
  }
  while (item = collection.shift()) {

    /*
     * item can be either of type "Array" or "Object"
     * API facets are normally mapped as arrays
     * while config or constructed entries (all deals) ar
     * mapped as object.
     */
    if (Array.isArray(item)) {
      if (!baseUrl) {
        continue;
      }
      id = item[0], friendlyName = item[1], count = item[2], subcategories = item[3];
      url = baseUrl + id;
    } else {
      id = item.i, friendlyName = item.n, count = item.c, subcategories = item.s, url = item.u, newBadge = item.newBadge;
    }
    ariaAttributes = ariaListAttributes = catInfo = newBadgeTag = '';
    countString = count ? " <span class='tw-count'>(" + count + ")</span>" : '';
    bhw = id ? baseBHW + toCamelCase(id) : baseBHW + 'AllDeal';
    if (newBadge && (newBadgeTxt = allTranslations.general.newbadge)) {
      newBadgeTag = "<span class='new-badge'>" + newBadgeTxt + "</span>";
    }
    if (subcategories != null ? subcategories.length : void 0) {
      attributes = templateAttributesForSubcategories(id, sectionID, prefix, bhw);
      htmlOpenTag = attributes[0], htmlCloseTag = attributes[1], ariaAttributes = attributes[2], ariaListAttributes = attributes[3], catInfo = attributes[4];
    } else {
      url = url ? "href='" + url + "' " : '';
      htmlOpenTag = "a " + url + "class='tw-link'";
      htmlCloseTag = 'a';
    }
    template = "<li class='tw-item tw-cat-item tw-cat-L" + level + "'" + ariaListAttributes + ">\n<" + htmlOpenTag + " data-bhw='" + bhw + "' " + catInfo + " " + ariaAttributes + ">" + newBadgeTag + friendlyName + countString + "</" + htmlCloseTag + ">\n</li>";
    list.push(template);
  }
  if (list.length) {
    menuID = sectionID.split('|').pop();
    list.unshift("<ul id='" + prefix + "tw-" + menuID + "-menu' class='tw-cat-menu tw-cat-menu-L" + level + "'>");
    list.push("</ul>");
  }
  return list.join('');
};


/**
 * Build Category lists and wrap them
 *
 * @param   {Array}   collections    - List of items
 * @param   {Array}   [prefix]       - Prefix for id generation (Optional)
 * @param   {Boolean} [m2016]        - Mobile2016 flag (Optional)
 * @returns {Object}  {list[]}       - List of categories
 */

partialSearchCategories = function(collections, prefix, m2016) {
  var collection, heading, item, listItems, type;
  if (prefix == null) {
    prefix = '';
  }
  if (m2016 == null) {
    m2016 = true;
  }
  item = collections[0];
  listItems = [];
  for (type in item) {
    collection = item[type];
    if (collection != null ? collection.length : void 0) {
      heading = getHeadingPartial(type);
      listItems.push("<li id='" + prefix + "tw-" + type + "' class='tw-category'>" + heading);
      listItems.push(partialSearchCategoryList(collection.slice(0), type, 1, prefix, m2016));
      listItems.push("</li>");
    }
  }
  return {
    list: listItems
  };
};


/**
 * Global method to generate the autocomplete list
 *
 * @param   {Array}  collections               - List of collections to process
 * @param   {String} query                     - Term entered by user
 * @param   {Object} [config]                  - Config object
 * @returns {Object} {list, index, bh, prefix}
 */

getAutocompleteList = function(collections, query, config) {
  var bh, data, finalList, index, indexShift, j, len1, list, normQuery, prefix, ref, ref1, ref2, ref3, ref4, ref5, tempList, widget;
  if (config == null) {
    config = {};
  }
  tempList = [];
  index = -1;
  indexShift = 0;
  prefix = '';
  normQuery = normalizeQuery(query);
  for (j = 0, len1 = collections.length; j < len1; j++) {
    ref = collections[j], data = ref.collection, widget = ref.widget;
    switch (widget) {
      case 'autocomplete':
        if (query) {
          ref1 = partialAutocompleteList(data, normQuery, indexShift), list = ref1.list, index = ref1.index, prefix = ref1.prefix;
        }
        break;
      case 'helperMessage':
        list = partialLocationHelper();
        break;
      case 'geolocation':
        ref2 = partialCurrentLocation(widget, normQuery, index), list = ref2.list, index = ref2.index;
        indexShift += list.length;
        break;
      case 'recentLocations':
        ref3 = partialRecentSearchesList(widget, data, config), list = ref3.list, prefix = ref3.prefix;
        break;
      case 'recentSearches':
        ref4 = partialRecentSearchesList(widget, data, config), list = ref4.list, prefix = ref4.prefix;
        break;
      case 'searchCategories':
        list = partialSearchCategories(data).list;
    }
    tempList.push.apply(tempList, list);
  }
  bh = widget === 'autocomplete' ? {
    type: 'bhc',
    val: "UserTyped:" + query
  } : {
    type: 'bhw',
    val: toCamelCase(widget)
  };
  ref5 = matchListItem(tempList, index), finalList = ref5.list, index = ref5.index;
  return {
    list: finalList,
    index: index,
    bh: bh,
    prefix: prefix
  };
};


/**
 * Get translations
 *
 * @param   {String} [key]
 * @returns {Object} translations - All translations or partial
 */

getTranslations = function(key) {
  var ref, translations;
  if (!Object.keys(allTranslations).length) {
    setTranslations((ref = Groupon.LS) != null ? ref.translations : void 0);
  }
  translations = typeof key === 'string' ? allTranslations[key] : allTranslations;
  return translations || {};
};


/**
 * Returns list of recent searches queries retrieved from localStorage
 *
 * param    {String} - Input type
 * @returns {Array}  - list
 */

getRecentSearches = function(type) {
  var list, ref, ref1;
  if (type == null) {
    type = 'deal';
  }
  list = [];
  try {
    switch (type) {
      case 'deal':
        list = JSON.parse(((ref = window.localStorage) != null ? ref.getItem('LS_recentSearches') : void 0) || '[]');
        break;
      case 'location':
        list = JSON.parse(((ref1 = window.localStorage) != null ? ref1.getItem('LS_recentLocations') : void 0) || '[]');
    }
  } catch (error) {}
  return list;
};


/**
 * Sets matching classes to list item when match indicated
 *
 * @param   {Array}  list          - List of items
 * @param   {Number} index         - Index of the item in the list that matched query
 * @returns {Object} {list, index}
 */

matchListItem = function(list, index) {
  var partial;
  if (index > -1) {
    partial = "<a class='typeahead-match typeahead-match-highlight";
    if (list[index].match(/<a class='/)) {
      list[index] = list[index].replace(/<a class='/, partial + " ");
    } else {
      list[index] = list[index].replace(/<a/, partial + "'");
    }
  }
  return {
    list: list,
    index: index
  };
};


/**
 * Move typeahead container into its context.
 * This is only needed for desktop
 *
 * @param {Object} $container - Selector for typeahead wrapper
 * @param {String} ctx        - Typeahead context
 * @param {String} env        - Environment
 */

moveAutocomplete = function($container, ctx, env) {
  var selector;
  if (env === 'desktop') {
    switch (ctx) {
      case 'search':
        selector = '.deal-search';
        break;
      case 'location':
        selector = '.location-search';
    }
    $(selector).append($container);
  }
};


/**
 * Returns Bloodhound tag name
 *
 * @param   {String|Object} value
 * @returns {String}        tag
 */

prepareBloodhoundTag = function(value) {
  var address, division, tag;
  tag = '';
  if (!value) {
    return tag;
  }
  if (typeof value === 'string') {
    tag = value;
  }
  if (typeof value === 'object') {
    division = value.division, address = value.address;
    tag = address || division;
  }
  if (typeof tag === 'string') {
    tag = tag.toLowerCase().replace(/[^\w\d]+/g, '_');
  }
  return tag;
};


/**
 * Convert, prepend and save term to recent searches list
 *
 * @param {String} term   - Deal query entered by user
 * @param {String} [type] - input type (Optional)
 */

removeRecentSearch = function(term, type) {
  var index, keywords;
  if (type == null) {
    type = 'deal';
  }
  if (type === 'search') {
    type = 'deal';
  }
  keywords = getRecentSearches(type) || [];
  term = _.escape(term).trim().toLowerCase();
  switch (type) {
    case 'deal':
      index = keywords.findIndex(function(n) {
        return n.toLowerCase() === term;
      });
      break;
    case 'location':
      index = keywords.findIndex(function(n) {
        var ref;
        return ((ref = n.address) != null ? ref.toLowerCase() : void 0) === term;
      });
  }
  if (index > -1) {
    keywords.splice(index, 1);
  }
  setRecentSearches(keywords, type);
};


/**
 * Helper function to remove stored searches
 *
 * @param {String} type - Input type
 */

removeRecentSearches = function(type) {
  if (type == null) {
    type = 'deal';
  }
  if (type === 'search') {
    type = 'deal';
  }
  switch (type) {
    case 'deal':
      window.localStorage.removeItem('LS_recentSearches');
      RecentSearches = [];
      break;
    case 'location':
      window.localStorage.removeItem('LS_recentLocations');
      RecentLocations = [];
  }
};


/**
 * Saves recent searches array as string in localStorage
 *
 * @param {Array}  keywords - List of keywords searched by user
 * @param {String} type     - input type
 */

setRecentSearches = function(keywords, type) {
  var key, ref;
  switch (type) {
    case 'deal':
      key = 'LS_recentSearches';
      break;
    case 'location':
      key = 'LS_recentLocations';
  }
  try {
    return (ref = window.localStorage) != null ? ref.setItem(key, JSON.stringify(keywords)) : void 0;
  } catch (error) {}
};


/**
 * Convert, prepend and save term to recent searches list
 *
 * @param {String} term - Deal query entered by user
 * @param {String} type - input type (Optional)
 * @param {String} env  - Environment. Controls amount of items (Optional)
 */

saveRecentSearch = function(term, type, env) {
  var amount, index, keywords;
  if (type == null) {
    type = 'deal';
  }
  if (env == null) {
    env = 'desktop';
  }
  amount = type === 'deal' && env === 'mobile' ? 5 : 10;
  keywords = getRecentSearches(type) || [];
  switch (typeof term) {
    case 'string':
      term = _.escape(term).trim().toLowerCase();
      if (term === '') {
        return;
      }
      index = keywords.findIndex(function(n) {
        return n === term;
      });
      break;
    case 'object':
      index = keywords.findIndex(function(n) {
        return n.address === term.address;
      });
  }
  if (index > -1) {
    keywords.splice(0, 0, keywords.splice(index, 1)[0]);
  } else {
    keywords.unshift(term);
  }
  setRecentSearches(keywords.slice(0, amount), type);
};


/**
 * Cache translations globally and make immutable
 *
 * @param   {Object} [translations]
 * @returns {Object} allTranslations
 */

setTranslations = function(translations) {
  if (translations == null) {
    translations = typeof Groupon !== "undefined" && Groupon !== null ? Groupon.LS.translations : void 0;
  }
  return allTranslations = Object.seal(translations);
};


/**
 * Get subcategory collection and its taxonomy level
 *
 * @param   {Array}                            collections
 * @param   {Array}                            path
 * @param   {Number}                           [level] - Taxonomy level
 * @returns {{collection.Array, level.Number}}
 */

getSubCategoryCollection = function(collections, path, level) {
  var collection, findSubCategory, id, temp;
  if (level == null) {
    level = 1;
  }
  collection = collections;
  id = void 0;

  /**
   * Condition to find matching item with categories
   * Checks if ID (i) matches and if subcategories (s) exists
   *
   * @param   {Object} item  - Array item
   * @returns {Boolean}      - Condition being passed to Array.prototype.find() to return object
   */
  findSubCategory = function(item) {
    var ref;
    return item[0] === id && ((ref = item[3]) != null ? ref.length : void 0);
  };

  /*
   * NOTE: This might be more efficient with Array::reduce
  
    findSubCategory = (item) ->
      if item[0] is id and item[3]?.length
        return item[3]
    level++ if (collection = collection.reduce(findSubCategory))
   */
  while (id = path.shift()) {
    if (temp = collection.find(findSubCategory)) {
      collection = temp[3].slice(0);
      level++;
    }
  }
  return {
    collection: collection,
    level: level
  };
};

module.exports = {
  createBloodhoundTag: createBloodhoundTag,
  getAutocompleteList: getAutocompleteList,
  getHeadingPartial: getHeadingPartial,
  getRecentSearches: getRecentSearches,
  getSubCategoryCollection: getSubCategoryCollection,
  getTranslations: getTranslations,
  deEmphasis: deEmphasis,
  matchListItem: matchListItem,
  moveAutocomplete: moveAutocomplete,
  partialAutocompleteList: partialAutocompleteList,
  partialCurrentLocation: partialCurrentLocation,
  partialLocationHelper: partialLocationHelper,
  partialRecentSearchesList: partialRecentSearchesList,
  partialSearchCategories: partialSearchCategories,
  partialSearchCategoryList: partialSearchCategoryList,
  prepareBloodhoundTag: prepareBloodhoundTag,
  removeRecentSearch: removeRecentSearch,
  removeRecentSearches: removeRecentSearches,
  saveRecentSearch: saveRecentSearch,
  setRecentSearches: setRecentSearches,
  setTranslations: setTranslations,
  templateAttributesForSubcategories: templateAttributesForSubcategories
};

